import { Stack, useTheme } from "@mui/material";
import { Check } from "lucide-react";
import type { FC } from "react";

const CIRCLE_SIZE = 64;
const ICON_SIZE = 32;

type Props = {
	color: string;
	bgcolor: string;
};

export const SuccessCheckCircle: FC<Props> = ({ color, bgcolor }) => {
	const { radii } = useTheme();

	return (
		<Stack
			width={CIRCLE_SIZE}
			height={CIRCLE_SIZE}
			borderRadius={radii.full}
			bgcolor={bgcolor}
			alignItems="center"
			justifyContent="center"
		>
			<Check size={ICON_SIZE} color={color} />
		</Stack>
	);
};
